import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { CreateButton } from 'shared/mui/Buttons';
import { ExportButton } from 'shared/react-admin/Buttons';
import { ListPage } from 'shared/react-admin/Pages';
import { Permission } from 'types/embedded/permission';

import { ProvidersFilter } from './ProvidersFilter';
import { ProvidersListDatagrid } from './ProvidersListDatagrid/ProvidersListDatagrid';

export const ProvidersList: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();

  return (
    <ListPage
      actions={[
        hasResourcePermissions(Resources.Providers, [Permission.Full, Permission.Create]) && (
          <CreateButton key="create-providers" />
        ),
        <ExportButton key="export-providers" />,
      ]}
      empty={false}
      headerTitle={{
        titleText: 'Провайдеры',
        tooltipText:
          'Сервис, предоставляющий услуги проведения и учета платежей в Интернет с помощью одного или нескольких методов.',
      }}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <ProvidersFilter />
      <ProvidersListDatagrid />
    </ListPage>
  );
};
